import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import s from './Sfirst.module.scss'

class Sfirst extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      opacity: 1
    }
  }
  
  componentDidMount() {
    if (this.refs.text) {
      setTimeout(() => {
        this.refs.text.style.opacity = 1
        this.refs.text.style.top = '0'
      }, 500)
    }
  }

  render() {
    const { locale } = this.props
    return (
      <div className={s.Sfirst} ref="Sfirst">
        <div className={s.text} ref="text">
          <div className={s.large}>
            <span>
              <FormattedMessage id="dk3_first_title" values={{br: ''}} />
            </span>
          </div>
          <div className={s.normal}>
            <FormattedMessage id="dk3_first_desc_1" />
            <span className={s.line}>·</span>
            <FormattedMessage id="dk3_first_desc_2" />
            <span className={s.line}>·</span>
            <FormattedMessage id="dk3_first_desc_3" />
            <span className={s.line}>·</span>
            <FormattedMessage id="dk3_first_desc_4" />
          </div>
        </div>
        <div
          className={
            locale.indexOf('US') > -1 
              ? s.IF_en
              : s.IF
          }
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language,
})

const SFirst = connect(mapStateToProps)(Sfirst)

export default SFirst
